import { useState } from 'react';

function App() {
  const [ selectedFile, setSelectedFile ] = useState(null);

  const handleFileInput = (event: any) => {
    setSelectedFile(event.target.files[0])
  }

  const onFileUpload = async (event: any) => {
    event.preventDefault();

    const body = new FormData();
    body.append("upload_preset", "preset_demo");
    body.append("file", selectedFile! as Blob);

    const res = await fetch(
      `/upload`,
      {
        method: "POST",
        body
      }
    )
    .then(response => response.json())
    .then(data => console.log(data))
    .catch(err => console.error(err));
  }

  return (
    <div className="App">
      <form>
        <input
          type="file" name="file"
          onChange={handleFileInput}
        />
        <button onClick={onFileUpload} type="submit">
          Upload
        </button>
      </form>
    </div>
  );
}

export default App;
